import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { TYPOGRAPHY } from '../../DesignSystem/typography';
import { Breakpoints } from '../../DesignSystem/design-system';
import { ImpFlex, ImpIcon } from '../..';
import { Icons } from '../../Icons/Icons';
import { colors } from '../../DesignSystem/colors';
// double digit thousands
const INPUT_MAX_LENGTH = 9;
const InputField = styled.input `
  padding: 0;
  font-feature-settings: 'ss02' on, 'ss09' on, 'zero' on;
  ${TYPOGRAPHY.display3.desktop}
  background-color: transparent;
  border: none;
  outline: none;
  text-align: center;
  // sets the width equal to the value of the input
  width: ${({ value }) => (value ? value.length + 'ch' : '2ch')};

  @media (max-width: ${Breakpoints.Mobile}) {
    ${TYPOGRAPHY.display3.mobile}
  }
`;
const createSyntheticEvent = (value) => ({
    nativeEvent: new Event('input', { bubbles: true }),
    currentTarget: { value },
    target: { value },
    isDefaultPrevented: () => false,
    isPropagationStopped: () => false,
    persist: () => { },
});
const setValueAndTriggerChange = (value, formatter, setInternalValue, onChange) => {
    const formattedValue = formatter ? formatter(value) : value;
    setInternalValue(formattedValue);
    if (onChange) {
        onChange(createSyntheticEvent(formattedValue));
    }
};
export default function ImpDisplayInput({ autofocus = false, maxLength = INPUT_MAX_LENGTH, clearButton = false, onChange, formatter, inputRef, value, }) {
    const componentInputRef = useRef();
    const [internalValue, setInternalValue] = useState('');
    const [dynamicWidth, setDynamicWidth] = useState(0);
    useEffect(() => {
        if (autofocus && (componentInputRef === null || componentInputRef === void 0 ? void 0 : componentInputRef.current)) {
            componentInputRef.current.focus();
        }
        else if (autofocus && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            inputRef.current.focus();
        }
    }, [autofocus]);
    useEffect(() => {
        if (value !== undefined && formatter) {
            setInternalValue(formatter(value));
        }
    }, [value, formatter]);
    const handleInputChange = (e) => {
        setValueAndTriggerChange(e.target.value, formatter, setInternalValue, onChange);
    };
    const clearInput = () => {
        setValueAndTriggerChange('', formatter, setInternalValue, onChange);
        const focusRef = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) || componentInputRef.current;
        if (focusRef) {
            focusRef.focus();
        }
    };
    const inputValue = value !== undefined ? value : internalValue;
    const formattedValue = formatter ? formatter(inputValue) : inputValue;
    const canClear = formatter
        ? formatter(inputValue) !== formatter('')
        : inputValue !== '';
    return (React.createElement(ImpFlex, { direction: "row", align: "center", justify: "center" },
        React.createElement(InputField, { ref: inputRef || componentInputRef, onChange: handleInputChange, value: formattedValue, maxLength: maxLength }),
        clearButton && (React.createElement(ImpIcon, { iconSrc: Icons.delete, size: "32px", stroke: canClear
                ? 'var(--merchant-color)'
                : colors.content.onBackgroundVariant, onClick: canClear ? clearInput : undefined }))));
}
//# sourceMappingURL=ImpDisplayInput.js.map